import { render, staticRenderFns } from "./ColorKitSwatchSelector.vue?vue&type=template&id=3711b0df&lang=pug&"
import script from "./ColorKitSwatchSelector.vue?vue&type=script&lang=js&"
export * from "./ColorKitSwatchSelector.vue?vue&type=script&lang=js&"
import style0 from "./ColorKitSwatchSelector.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports